import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class CircularProgressBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = { startAnimation: false };

    this.prepareTimeout = this.prepareTimeout.bind(this);
    this.clearTimeout = this.clearTimeout.bind(this);
  }

  componentDidMount() {
    this.prepareTimeout();
  }

  componentWillUnmount() {
    this.clearTimeout();
  }

  timeoutHandle;

  prepareTimeout() {
    this.clearTimeout();
    this.timeoutHandle = setTimeout(() => {
      this.setState({ startAnimation: true });
      this.timeoutHandle = 0;
    }, 5);
  }

  clearTimeout() {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = 0;
    }
  }

  render() {
    const {
      value,
      className,
    } = this.props;
    const {
      startAnimation,
    } = this.state;

    const progressValue = Math.min(Math.max(value, 0), 100);
    const radius = 24;
    const alternativeRadius = 14;

    const getCircles = (r, strokeWidth, strokeLinecap, animated, key) => {
      const circumference = r * 2 * Math.PI;
      const offset = circumference - ((progressValue / 100) * circumference);
      const style = {
        strokeDasharray: startAnimation ? `${circumference - offset} ${offset}` : `0 ${circumference}`,
      };
      return [
        <circle
          key={`${key}-background`}
          className={classnames('progress-bar-background')}
          strokeLinecap={strokeLinecap}
          fill="none"
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={0}
          cx="28"
          cy="28"
          r={r}
        />,
        <circle
          key={key}
          className={classnames('progress-bar', animated ? 'animated' : '')}
          style={style}
          strokeLinecap={strokeLinecap}
          strokeWidth={strokeWidth}
          fill="none"
          cx="28"
          cy="28"
          r={r}
        />,
      ];
    };

    return (
      <div className={classnames('CircularProgressBar', className)}>
        <div className="progress-container">
          <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" className="progress-bar-container">
            { getCircles(radius, '7px', 'square', startAnimation, 'progress-bar')}
          </svg>
          <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" className="progress-bar-container-alternative">
            { getCircles(alternativeRadius, '27.5px', 'butt', startAnimation, 'progress-bar-alternative') }
          </svg>
        </div>
        <div className="progress-bar-value">
          <p>{`${value}%`}</p>
        </div>
      </div>
    );
  }
}

CircularProgressBar.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};

CircularProgressBar.defaultProps = {
  value: 0,
  className: '',
};

export default CircularProgressBar;
